export enum InteractionButtonType {
  Check,
  Submit,
  Complete,
  Save,
  SaveEdited,
}

export const buttonLabels: Record<InteractionButtonType, string> = {
  [InteractionButtonType.Check]: 'assignment.actions.primary.check',
  [InteractionButtonType.Submit]: 'assignment.actions.primary.submit',
  [InteractionButtonType.Complete]: 'assignment.actions.primary.complete',
  [InteractionButtonType.Save]: 'assignment.actions.primary.save',
  [InteractionButtonType.SaveEdited]: 'assignment.actions.primary.save_edited',
};
